<template>
  <div>
    <v-toolbar card color="white">
      <v-toolbar-items>
        <v-menu
          v-model="menuFilterDate"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          class="mr-2"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="filterDate"
              prepend-inner-icon="event"
              readonly
              v-on="on"
              solo
              class="date-box"
            ></v-text-field>
          </template>
          <v-date-picker v-model="filterDate" @input="menuFromDate = false"></v-date-picker>
        </v-menu>
      </v-toolbar-items>
      <v-btn class="mx-0" color="primary" @click="getActionLogList" :disabled="disabledDownload">Download</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-combobox solo class="toolbar-item" v-model="selectedGroup" :items="group" label="App" @change="changeGroupApp"></v-combobox>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>

    <v-data-table
      item-key="id"
      :headers="headers"
      :items="listFilter"
      :rows-per-page-items="[10,20,50,100]"
      :loading="isLoading"
      class="table-worktime"
    >
      <template slot="items" slot-scope="props">
        <tr class="table-row">
          <td>{{ props.item.lastmodified | formatDateTime}}</td>
          <td>{{ props.item.action }}</td>
          <td>{{ props.item.appName }}</td>
          <td> {{ props.item.entity }}</td>
          <td>{{ props.item.companyUsername }}</td>
          <td>{{ props.item.oldData }}</td>
          <td>{{ props.item.newData }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  formatGMTToLocalTime,
  convertDateTimeToSecond2010,
  convertSecond2010ToDateTime,
  convertGMTToLocalTime
} from '@/utils/datetime';
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
  filters: {
    formatDateTime (dt) {
      return moment(dt * 1000).format('YYYY-MM-DD HH:mm');
    }
  },

  data: () => ({
    headers: [
      { text: 'Thời gian', value: 'lastmodified' },
      { text: 'Hành động', value: 'action' },
      { text: 'Ứng dụng', value: 'appName' },
      { text: 'Đối tượng', value: 'entity' },
      { text: 'Username', value: 'companyUsername' },
      { text: 'Dữ liệu cũ', value: 'oldData' },
      { text: 'Dữ liệu mới', value: 'newData' }
    ],
    group: ['All'],
    selectedGroup: 'All',
    list: [],
    listFilter: [],
    filterDate: moment().format('YYYY-MM-DD'), 
    menuFilterDate: false,
    isLoading: false,
    disabledDownload: false
  }),

  async created () {
    await this.getActionLogList();
  },

  methods: {
    ...mapActions(['getActionLog']),

    async getActionLogList () {
      let res = await this.getActionLog({ time: this.getTime() }).catch(_ => {
        return null;
      });

      if (res) this.list = res;
      this.listFilter = this.list;
      let appNames = this.list.map(item => item.appName);
      this.group = ['All', ...appNames];
    },

    getTime () {
      let date =  new Date(this.filterDate);
      return Math.floor(date.getTime() / 1000);
    },

    changeGroupApp (val) {
      if (val !== 'All') { this.listFilter = this.list.filter(item => item.appName === val) }
      else { this.listFilter = this.list }
    }
  }
};
</script>

<style scoped>
.v-toolbar__items {
  padding: 7px !important;
}
.toolbar-item {
  width: 200px !important;
  margin-right: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/HistoryLogs.vue